import { ROUTES } from '@/router/routeNames'

export default [
  {
    name: ROUTES.ATTRIBUTION,
    path: 'attribution',
    component: () => import('./pages/AttributionIndex.vue'),
    meta: {
      settingsMode: true,
      title: 'Lead Attribution',
      description:
        'Automatically synchronize data about how a lead ended up on your website to your email platform / CRM.',
      helpResource: 'attribution.default'
    }
  }
]
